<form [formGroup]="form" (ngSubmit)="save()">
    <div class="tab-card-grid-2">
        <div class="tab-card" style="margin-bottom: 0;">
            <div class="tab-card-header">
                <span class="tab-icon-badge" style="background:#fbe4d0;"><img src="assets/img/icons/section-direccion.svg" alt=""></span>
                <h5>Dirección</h5>
            </div>

            <div class="field-row">
                <div class="field-col" style="flex-basis: 100%;">
                    <label class="field-label">Calle y numero</label>
                    <input type="text" class="field-input" formControlName="street_number">
                </div>
            </div>
            <div class="field-row">
                <div class="field-col" style="flex-basis: 100%;">
                    <label class="field-label">Colonia</label>
                    <input type="text" class="field-input" formControlName="neighborhood">
                </div>
            </div>
            <div class="field-row">
                <div class="field-col" style="flex-basis: 100%;">
                    <label class="field-label">Código postal</label>
                    <input type="text" class="field-input" formControlName="zip_code">
                </div>
            </div>
            <div class="field-row">
                <div class="field-col" style="flex-basis: 100%;">
                    <label class="field-label">Población/Ciudad</label>
                    <input type="text" class="field-input" formControlName="city">
                </div>
            </div>
            <div class="field-row">
                <div class="field-col" style="flex-basis: 100%;">
                    <label class="field-label">Estado</label>
                    <input type="text" class="field-input" formControlName="state">
                </div>
            </div>

            <div class="employee-location-preview" #previewMap></div>

            <button type="button" class="tab-inline-badge-btn mt-2" (click)="openLocationModal()">
                <i class="ti ti-map-pin"></i> Cambiar ubicación
            </button>
        </div>

        <div class="d-flex flex-column gap-3">
            <div class="tab-card">
                <div class="tab-card-header">
                    <span class="tab-icon-badge" style="background:#ffccf0;"><img src="assets/img/icons/section-contacto.svg" alt=""></span>
                    <h5>Contacto</h5>
                </div>
                <div class="field-row">
                    <div class="field-col" style="flex-basis: 100%;">
                        <label class="field-label">Correo electrónico 1</label>
                        <input type="email" class="field-input" formControlName="email_1"
                            [class.is-invalid]="f['email_1'].errors && !f['email_1'].pristine">
                        <div class="invalid-feedback" *ngIf="f['email_1'].errors && !f['email_1'].pristine">
                            Ingrese un correo electrónico válido
                        </div>
                    </div>
                </div>
                <div class="field-row">
                    <div class="field-col" style="flex-basis: 100%;">
                        <label class="field-label">Correo electrónico 2</label>
                        <input type="email" class="field-input" formControlName="email_2"
                            [class.is-invalid]="f['email_2'].errors && !f['email_2'].pristine">
                        <div class="invalid-feedback" *ngIf="f['email_2'].errors && !f['email_2'].pristine">
                            Ingrese un correo electrónico válido
                        </div>
                    </div>
                </div>
                <div class="field-row">
                    <div class="field-col">
                        <label class="field-label">Teléfono 1</label>
                        <input type="text" class="field-input" formControlName="phone_1">
                    </div>
                    <div class="field-col">
                        <label class="field-label">Teléfono 2</label>
                        <input type="text" class="field-input" formControlName="phone_2">
                    </div>
                </div>
            </div>

            <div class="tab-card">
                <div class="tab-card-header">
                    <span class="tab-icon-badge" style="background:#ccffdf;"><img src="assets/img/icons/section-otros.svg" alt=""></span>
                    <h5>Otros</h5>
                </div>
                <div class="field-row">
                    <div class="field-col" style="flex-basis: 100%;">
                        <label class="field-label">Estado civil</label>
                        <select class="field-select" formControlName="marital_status">
                            <option value="">Seleccionar</option>
                            <option *ngFor="let m of maritalStatuses" [value]="m">{{m}}</option>
                        </select>
                    </div>
                </div>
                <div class="field-row">
                    <div class="field-col" style="flex-basis: 100%;">
                        <label class="field-label">Tipo de sangre</label>
                        <select class="field-select" formControlName="blood_type">
                            <option value="">Seleccionar</option>
                            <option *ngFor="let b of bloodTypes" [value]="b">{{b}}</option>
                        </select>
                    </div>
                </div>
                <div class="field-row">
                    <div class="field-col" style="flex-basis: 100%;">
                        <label class="field-label">Entidad federativa</label>
                        <select class="field-select" formControlName="federal_entity">
                            <option value="">Seleccionar</option>
                            <option *ngFor="let s of states" [value]="s">{{s}}</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="tab-card">
        <div class="tab-card-header">
            <span class="tab-icon-badge" style="background:#d0dafb;"><img src="assets/img/icons/section-formacion-academica.svg" alt=""></span>
            <h5>Formación académica</h5>
        </div>
        <div class="field-row">
            <div class="field-col">
                <label class="field-label">Nivel de estudios</label>
                <select class="field-select" formControlName="education_level">
                    <option value="">Seleccionar</option>
                    <option *ngFor="let e of educationLevels" [value]="e">{{e}}</option>
                </select>
            </div>
            <div class="field-col">
                <label class="field-label">Profesión/Carrera</label>
                <input type="text" class="field-input" formControlName="profession">
            </div>
        </div>
    </div>

    <div class="tab-save-bar" *ngIf="canDo('Editar')">
        <button type="submit" class="btn btn-primary">Guardar cambios</button>
    </div>
</form>

<div class="modal fade" id="employeeLocationModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content p-2 p-md-3">
            <div class="modal-header">
                <h5 class="modal-title">Cambiar ubicación</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <label class="field-label">Buscar dirección</label>
                <input type="text" class="field-input mb-3" placeholder="Escribe una dirección..." autocomplete="off"
                    [appGooglePlaces]="null" (appGooglePlacesPlaceChanged)="onPlaceChanged($event)">
                <div class="employee-location-modal-map" #modalMap></div>
                <p class="text-muted small mt-2 mb-0">Puedes arrastrar el marcador para ajustar la ubicación exacta.</p>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-outline-primary" data-bs-dismiss="modal">Cancelar</button>
                <button type="button" class="btn btn-primary" (click)="confirmLocation()">Confirmar ubicación</button>
            </div>
        </div>
    </div>
</div>
